import { columns } from "./columns";
import { DataTable } from "./data-table";
import { getSchema } from "./schema.jsx";

export default function ViewSchemaTable() {
  const data = getSchema();
  return <DataTable columns={columns} data={data} />;
}
